import { Radio } from '@mantine/core';
import Icon from '@ui/components/Icon/Icon';

const RADIO_STYLES = {
	inner: { marginTop: -2, width: 14, height: 14 },
	radio: { zIndex: -1, width: 0, height: 0, border: 0 }
};

const CheckIcon = () => <Icon icon="radio_button_checked" size={14} />;
const UncheckIcon = () => <Icon icon="radio_button_unchecked" size={14} />;
const RoleSelectorRadioIcon = ( {
	checked, label, disabled = false
}: {
	checked: boolean;
	label: string;
	disabled?: boolean;
} ) => (
	<Radio
		styles={RADIO_STYLES}
		checked={checked}
		aria-label={label}
		aria-checked={checked}
		role="radio"
		size="xs"
		disabled={disabled}
		icon={checked ? CheckIcon : UncheckIcon}
		readOnly
	/>
);

export default RoleSelectorRadioIcon;
